import React, { useContext, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import CircularList from "./CircularList";

const CollegeCircular = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);

  return (
    <>
      <Header backAction={true} title="Leave List" />

      <div className="">
        <div className="container">
          <section className="top-space pt-0 pb-0">
            <CircularList titleText={"Leave List"} />
          </section>
          <section className="top-space "></section>
        </div>
      </div>
    </>
  );
};
export default CollegeCircular;
